import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { token } from "../Actions/AuthAction";
import { selectedDriveCandidatesList } from "../Actions/CandidateAction";
import Shimmer from "../Common/Shimmer";
import { DriveSelectedCandidateList } from "./DriveSelectedCandidateList";

export const SelectedCandidateDriveList = () => {
  const [candidateList, setCandidateList] = useState(null);
  const [type, setType] = useState(2);
  const driveID = useParams().id;

  useEffect(() => {
    selectedDriveCandidatesList({
      loginusertoken: token(),
      driveid: driveID,
    }).then((res) => {
      if (res.status) {
        let newData = [];
        res.data.map((item) => newData.push(item));
        setCandidateList(newData);
      }
    });
  }, []);
  return (
    <div>
      {candidateList ?
        <DriveSelectedCandidateList
          driveid={driveID}
          type={"2"}
          select={true}
          candidateList={candidateList}
          heading={`SELECTED CANDIDATE LIST FOR DRIVE ID: ${driveID}`}
        /> :
        <div className="d-flex justify-content-center align-items-center errorpage">
          <div className="col-md-6 text-center">
            <h2 style={{ fontSize: "100px" }}>😕</h2>
            <h6 style={{ paddingBottom: "20px" }}>No Candidate is selected in this drive</h6>
            <Link to="/drivelist" class="btn btn-primary-custom">Go to Drive List</Link>
          </div>
        </div>
      }
    </div>
  );
};
